import React, { useContext, useEffect, useRef, useState } from 'react';
import { MessageLogContext } from '../../contexts/MessageLogContext'; // Adjust path if needed
import styles from './MainPanel2.module.css';

const MainPanel2 = () => {
  const { messages } = useContext(MessageLogContext);
  const logEndRef = useRef(null);
  const [isExpanded, setIsExpanded] = useState(false); // Start collapsed as a bottom bar

  useEffect(() => {
    // Auto-scroll to the bottom when new messages are added
    logEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  useEffect(() => {
    // Auto-scroll to the bottom when the log is opened
    if (isExpanded) {
      // Small delay to ensure DOM is rendered before scrolling
      setTimeout(() => {
        logEndRef.current?.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    }
  }, [isExpanded]);

  const getMessageClass = (type) => {
    switch (type) {
      case 'success':
        return styles.logSuccess;
      case 'error':
        return styles.logError;
      case 'warning':
        return styles.logWarning;
      case 'info':
      default:
        return styles.logInfo;
    }
  };

  return (
    <div className={`${styles.mainPanel2Container} ${isExpanded ? styles.expanded : ''}`}>
      <button 
        className={styles.logHeader} 
        onClick={() => setIsExpanded(!isExpanded)}
        title={isExpanded ? "Collapse System Log" : "Expand System Log"}
      >
        <h3 className={styles.logTitle}>
          System Log 
          <span className={styles.messageCount}>({messages.length})</span>
        </h3>
        <span className={`${styles.arrow} ${isExpanded ? styles.open : ''}`}>&#9660;</span>
      </button>
      {isExpanded && (
        <div className={styles.messageLog}>
          {messages.length === 0 && <p className={styles.emptyLogMessage}>No messages yet.</p>}
          {messages.map((msg, index) => (
            <p key={`${msg.timestamp}-${index}`} className={`${styles.logMessage} ${getMessageClass(msg.type)}`}>
              {msg.text}
            </p>
          ))}
          <div ref={logEndRef} />
        </div>
      )}
    </div>
  );
};

export default MainPanel2;